import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import {
  Anchor,
  Section,
  Flex,
  Text,
  Columns,
  Br,
  Card,
} from '../../../components/blocks';

import { margin, MarginProps } from '../../../components/styles';

type Props = MarginProps & { ref?: string };

import ImgTel from '../../../images/banner/img-tel.svg';
import ImgMail from '../../../images/banner/img-mail.svg';

const Root = styled.div<Props>`
  width: 100%;
  padding: ${({ theme }) => `${theme.spaces.xxl} 0`};
  background: ${({ theme }) => theme.backgroundColors.primary};
  ${margin}

  svg {
    ${({ theme }) =>
      theme.screen.min({
        width: '32px',
        height: '32px',
      })}
  }
`;

const CardInner = styled(Flex)`
  ${({ theme }) =>
    theme.screen.sp({
      gap: theme.spaces.l,
    })}
`;

export const FooterComfirms: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <Root mt={props.mt}>
      <Section gap="xl">
        <Flex flexDirection="column" alignItems="center" width="100%">
          <Text
            as="h2"
            size="xxl"
            fontWeight="bold"
            lineHeight="m"
            color="white"
            textAlign="center"
          >
            <ruby>
              Dentis<rt>デンティス</rt>
            </ruby>
            導入について
            <Br sponly />
            ご不明な点がございましたら
            <br />
            お気軽にお問い合わせください
          </Text>
        </Flex>

        <Columns column="two" alignItems="initial" width="100%">
          <Columns.Item>
            <Card bgColor="white" radii="m" p={theme.spaces.xl}>
              <CardInner alignItems="center" gap={theme.spaces.xxl}>
                <ImgMail
                  width="64"
                  height="64"
                  alt="mail"
                  css={{ flexShrink: 0 }}
                />
                <Flex
                  flexDirection="column"
                  alignItems="flex-start"
                  gap={theme.spaces.m}
                >
                  <Text as="h3" size="l" fontWeight="bold">
                    お問い合わせ
                  </Text>
                  <Text size="s" lineHeight="l">
                    Dentis専任スタッフが、導入方法や機能活用方法など丁寧にお答えいたします。
                  </Text>
                  <Anchor to="/form/inquiry" fill radius="rounded" wide="l">
                    お問い合わせ
                  </Anchor>
                </Flex>
              </CardInner>
            </Card>
          </Columns.Item>

          <Columns.Item>
            <Card bgColor="white" radii="m" height="100%" p={theme.spaces.xl}>
              <CardInner alignItems="center" gap={theme.spaces.xxl}>
                <ImgTel
                  width="64"
                  height="64"
                  alt="tel"
                  css={{ flexShrink: 0 }}
                />
                <Flex
                  flexDirection="column"
                  alignItems="flex-start"
                  gap={theme.spaces.m}
                >
                  <Text as="h3" size="l" fontWeight="bold">
                    電話でのお問い合わせ
                  </Text>
                  <Flex flexDirection="column" alignItems="flex-start">
                    <Text size="s" display="block" fontWeight="bold">
                      株式会社メドレー Dentis事業推進室
                    </Text>
                    <a href="tel:050-1751-0849">
                      <Text size="xxxl" fontWeight="bold">
                        050-1751-0849
                      </Text>
                    </a>
                    <Text size="xs" display="block" mb={theme.spaces.s}>
                      受付時間：10:00〜18:00（土日祝・年末年始休み）
                    </Text>
                  </Flex>
                </Flex>
              </CardInner>
            </Card>
          </Columns.Item>
        </Columns>
      </Section>
    </Root>
  );
};
